
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer/[customer_shopify_id]",
      function () {
        return require("private-next-pages/customer/[customer_shopify_id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer/[customer_shopify_id]"])
      });
    }
  